import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWordpressComponent } from './simple-icons-wordpress.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWordpressComponent ],
    exports:      [ SimpleIconsWordpressComponent ],
    bootstrap:    []
})
export class SimpleIconsWordpressModule {}
